import { gql } from '@apollo/client';

export const CREATE_SURROUNDING_INFORMATION_CATEGORY_MUTATION = gql`
  mutation CreateSurroundingInformationCategory($data: SurroundingInformationCategoryInput!) {
    createSurroundingInformationCategory(input: { data: $data }) {
      surroundingInformationCategory {
        id
      }
    }
  }
`;
